(function () {
  'use strict';
  var address = new URL(location.href);
  document.querySelectorAll('[data-sort-form], .lib-tb-f').forEach(function (form) {
    var per = form.querySelector('[name=per]');
    if (per && Array.from(per.options).some(function (o) { return o.value === address.searchParams.get('per'); })) per.value = address.searchParams.get('per');
    form.querySelectorAll('select').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(location.href);
        form.querySelectorAll('select').forEach(function (s) { url.searchParams.set(s.name, s.value); });
        url.searchParams.delete('page');
        location.assign(url.pathname + url.search);
      });
    });
  });
  document.querySelectorAll('[data-find], .lib-find').forEach(async function (find) {
    var section = find.closest('.shopify-section');
    if (section) find.dataset.section = section.id.replace('shopify-section-', '');
    var size = Number(find.dataset.per), per = Number(address.searchParams.get('per'));
    var pages = Number(find.dataset.pages), page = Number(find.dataset.page);
    var target = per === 48 || per === 96 ? per : size;
    var m = target / size, last = page;
    var grid = find.querySelector('.grid-books, ul.lib-grid');
    var cards = find.hasAttribute('data-find') ? 'a.book' : 'li.lib-gcard';
    if (!grid || !size) return;
    try {
      while (grid.querySelectorAll(cards).length < target && last < pages) {
        var url = new URL(location.href);
        url.searchParams.set('page', last + 1);
        url.searchParams.set('section_id', find.dataset.section);
        var response = await fetch(url.pathname + url.search);
        if (!response.ok) throw new Error();
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var incoming = doc.querySelector('[data-find] .grid-books, .lib-find ul.lib-grid');
        if (!incoming) break;
        incoming.querySelectorAll(cards).forEach(function (card) {
          if (grid.querySelectorAll(cards).length < target) grid.appendChild(card);
        });
        last++;
      }
      var pager = find.querySelector('.pager, .lib-pager');
      if (!pager) return;
      pager.querySelector('[data-page-label]').textContent = find.dataset.pageLabel.replace('@n@', Math.floor((page - 1) / m) + 1).replace('@total@', Math.ceil(pages / m));
      ['prev', 'next'].forEach(function (rel) {
        var link = pager.querySelector('a[rel=' + rel + ']');
        var nextPage = rel === 'prev' ? page - m : last + 1;
        if (!link) return;
        if (nextPage < 1 || nextPage > pages) { link.hidden = true; return; }
        var url = new URL(location.href);
        url.searchParams.delete('section_id');
        url.searchParams.set('page', nextPage);
        link.href = url.pathname + url.search;
      });
    } catch (_) { /* Keep the server-rendered pager usable. */ }
  });
  var panel = document.getElementById('library-filters');
  var opener = document.querySelector('[data-filters-open]');
  var scrim = document.querySelector('[data-filter-scrim], .lib-scrim');
  var modern = panel && panel.classList.contains('drawer');
  var overflow = '';
  function close() {
    if (!panel || !opener) return;
    panel.classList.remove('on');
    if (modern) { panel.hidden = true; panel.style.display = 'none'; }
    opener.setAttribute('aria-expanded', 'false');
    if (scrim) scrim.hidden = true;
    document.body.classList.remove('lib-filters-lock');
    document.body.style.overflow = overflow;
    opener.focus();
  }
  if (panel && opener) {
    opener.addEventListener('click', function (event) {
      event.preventDefault();
      overflow = document.body.style.overflow;
      panel.classList.add('on');
      if (modern) { panel.hidden = false; panel.style.display = 'flex'; }
      opener.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.hidden = false;
      document.body.style.overflow = 'hidden';
      panel.querySelector('[data-filters-close]').focus();
    });
    panel.querySelectorAll('[data-filters-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    panel.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !panel.classList.contains('on')) return;
      var controls = panel.querySelectorAll('a[href], button:not([disabled]), input, select');
      var first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }
  var input = document.getElementById('library-search-page-q');
  var box = document.querySelector('[data-suggest]');
  var timer, version = 0;
  function hideSuggest() { version++; if (box) box.hidden = true; }
  if (input && box) {
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var current = ++version, query = input.value.trim();
      if (query.length < Number(box.dataset.min)) { box.hidden = true; return; }
      timer = setTimeout(async function () {
        var url = new URL(box.dataset.url, location.origin);
        if (url.origin !== location.origin) return;
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product,collection');
        url.searchParams.set('resources[limit]', box.dataset.limit);
        url.searchParams.set('section_id', box.dataset.section);
        try {
          var response = await fetch(url.pathname + url.search);
          if (!response.ok) throw new Error();
          var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          var suggestions = doc.querySelector('.lib-sg');
          if (current !== version) return;
          box.replaceChildren();
          if (suggestions && suggestions.querySelector('a')) { box.appendChild(suggestions); box.hidden = false; }
          else box.hidden = true;
        } catch (_) { if (current === version) box.hidden = true; }
      }, 250);
    });
    document.addEventListener('click', function (event) { if (!box.contains(event.target) && event.target !== input) hideSuggest(); });
  }
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') { hideSuggest(); if (panel && panel.classList.contains('on')) close(); } });
  if ('IntersectionObserver' in window) document.querySelectorAll('.lib-shelf-pg').forEach(function (page) {
    var bar = page.querySelector('[data-bar]'), starts = page.querySelectorAll('[data-start]');
    if (!bar || !starts.length) return;
    var first = starts[0], last = starts[starts.length - 1], passed = false, nearLast = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === first) passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        if (entry.target === last) nearLast = entry.isIntersecting;
      });
      bar.hidden = !passed || nearLast;
    });
    observer.observe(first);
    if (last !== first) observer.observe(last);
  });
  var shelfForm = document.getElementById('library-shelf-form');
  if (shelfForm) {
    var sent = document.querySelector('[data-shelf-sent]');
    var error = document.querySelector('[data-shelf-error]');
    var sending = false;
    shelfForm.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (sending) return;
      sending = true;
      if (sent) sent.hidden = true;
      if (error) error.hidden = true;
      try {
        var response = await fetch(shelfForm.action, {
          method: 'POST',
          body: new FormData(shelfForm),
          credentials: 'same-origin'
        });
        if (new URL(response.url, location.origin).pathname.indexOf('/challenge') !== -1) {
          HTMLFormElement.prototype.submit.call(shelfForm);
          return;
        }
        if (!response.ok) throw new Error();
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (doc.querySelector('.errors, [data-shelf-error]:not([hidden])')) throw new Error();
        shelfForm.reset();
        if (sent) sent.hidden = false;
      } catch (_) {
        if (error) error.hidden = false;
      } finally {
        sending = false;
      }
    });
  }
}());
